import React from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft, Brush } from '@mui/icons-material';
import { useChatContext } from '../context/ChatContext';

const RightSidebar: React.FC = () => {
  const { uiState, toggleRightSidebar } = useChatContext();
  const collapsed = uiState.rightSidebarCollapsed;

  return (
    <div
      className={`sidebar-right${collapsed ? ' collapsed' : ''}`}
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        height: '100%',
        width: collapsed ? '60px' : '800px',
        zIndex: 10,
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'flex',
        flexDirection: 'column',
        borderLeft: '1px solid var(--neutral-light)',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden'
      }}
    >
      {/* Header */}
      <div
        className="sidebar-header sidebar-top-row"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 16px',
          borderBottom: '1px solid var(--neutral-light)',
          height: '56px',
          justifyContent: 'flex-end'
        }}
      >
        <IconButton
          onClick={toggleRightSidebar}
          className="sidebar-toggle-btn"
          style={{
            transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.3s',
            marginRight: '-6px'
          }}
        >
          <ChevronLeft />
        </IconButton>
      </div>

      {/* Content: only show when expanded */}
      {!collapsed && (
        <div className="canvas-coming-soon">
          <Brush className="canvas-icon" />
          <div className="canvas-title">
            Canvas coming soon!
          </div>
          <div className="canvas-description">
            A visual workspace for your AI conversations
          </div>
        </div>
      )}
    </div>
  );
};

export default RightSidebar; 